module.exports = __webpack_public_path__ + "static/media/fast-forward.43f978f7.svg";